import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';
import '@/js/modules/jquery_datepicker_defaults';

onPageLoad(() => {
  $(document).on(
    'click',
    '.h-s-button--save-contract, .h-s-button--save-and-preview-contract',
    (e) => {
      const $form = $('form.contract-form');
      if (!$form[0].checkValidity()) {
        setTimeout(() => {
          window.scrollTo({ top: 0 });
        }, 50);
        setTimeout(() => {
          $form[0].reportValidity();
        }, 150);
        return;
      }

      let submitAction;
      if ($(e.target).is('.h-s-button--save-contract')) {
        submitAction = 'Save';
      } else if ($(e.target).is('.h-s-button--save-and-preview-contract')) {
        submitAction = 'Save & Preview';
      }

      $form.find('[name=submit_action]').val(submitAction);
      $form.submit();

      return false;
    }
  );

  $(document).on('submit', '.contract-form', (e) => {
    const submitActionEl = $('form.contract-form').find('[name=submit_action]');

    if (submitActionEl.length < 1) {
      return true;
    }

    const submitAction = submitActionEl.val();

    if (!submitAction.length) {
      return false;
    }
  });

  // disable share button if no clients are present in the contract
  $(document).on('clients--client-selector:change', '.contract-form', (e) => {
    const clients = e.originalEvent?.detail?.clients || [];
    $('.p-button--send-contract-unified').toggleClass('button-disabled', clients.length === 0);
  });

  $(document).on('click', '.p-button--send-contract-unified', (e) => {
    e.preventDefault();
    const $form = $('form.contract-form');
    if (!$form[0].checkValidity()) {
      setTimeout(() => {
        window.scrollTo({ top: 0 });
      }, 50);
      setTimeout(() => {
        $form[0].reportValidity();
      }, 150);
      return;
    }

    $form.find('[name=submit_action]').val('Send');
    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: $form.serialize(),
      headers: { Accept: 'text/vnd.turbo-stream.html' },
    }).done((html) => window.Turbo.renderStreamMessage(html));
  });

  $(document).on('click', '.dropdown-menu__link--delete-contract', (e) => {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-contract-confirmation').modal();
    $('#modal--delete-contract-confirmation .d-button--confirm-delete').attr('href', deleteUrl);

    return false;
  });

  $(document).on('change', '.checkbox--client-agreed-to-terms', (e) => {
    $('.p-button--sign-contract').toggleClass('button-disabled', !$(e.target).is(':checked'));
  });

  if ($('.field--designer-signed-date').length) {
    $('.field--designer-signed-date').datepicker();
  }
});
